import { useTranslation } from 'gatsby-plugin-react-i18next';

// TODO: Will remove once localization working fine
enum TempTags {
    "product.tile.tagNew" = "New",
    "product.tile.tagInstore" = "In Store Only",
    "product.tile.tagIncompatiblelRx" = "Incompatible Rx",
}

export const Tag = ({ tagTitle, className }: { tagTitle: string, className?: string }) => {
    const { t } = useTranslation();
    let localizedTagTitle = t(tagTitle);
    // TODO: Will remove once localization working fine
    if ((TempTags as any)[localizedTagTitle]) {
        localizedTagTitle = (TempTags as any)[localizedTagTitle]
    }
    return tagTitle && (
        <div data-testid={`tag-${tagTitle}`}
            aria-label={`${localizedTagTitle} tag`}
            className={`flex justify-center align-center rounded text-black font-medium p-1 md:p-2 md:pt-[3px] md:pb-[3px] md:pl-[6px] md:pr-[6px]  ${localizedTagTitle === 'New' ? 'text-white bg-[#003B71]': 'text-black bg-[#F69D26]'} ${className}`}>
            {localizedTagTitle}
        </div>
    )
}